export const createParamConfig = (baseValue, options = {}) => {
  const { maxRate = 3, minRate = 0.1 } = options
  const base = Math.floor(baseValue)
  return {
    base,
    max: Math.floor(base * maxRate),
    min: Math.floor(base * minRate)
  }
}

export const loadImage = (url) => {
  return new Promise((resolve, reject) => {
    const image = new Image()
    image.crossOrigin = 'anonymous'
    image.onload = () => resolve(image)
    image.onerror = (err) => reject(new Error(`Image load failed: ${err}`))
    image.src = url
  })
}

export const canvasToBlob = (canvas) => {
  return new Promise((resolve) => {
    canvas.toBlob((blob) => resolve(blob), 'image/png')
  })
}
